import { _ as t } from "../internals/export.js";
var a = Math.asinh,
  r = Math.log,
  i = Math.sqrt;
t({
  target: "Math",
  stat: !0,
  forced: !(a && 1 / a(0) > 0)
}, {
  asinh: function t(a) {
    var n = +a;
    return isFinite(n) && 0 != n ? n < 0 ? -t(-n) : r(n + i(n * n + 1)) : n;
  }
});